import {connect} from 'react-redux';
import {AnimationSequence as Component} from './AnimationSequence';
import {
  showModal,
  setModal,
  incSolution,
  decSolution,
  setSolutionMixed,
  prepareGelBox,
  runGel,
  visualizeGel,
  loadDNALadder,
  putOnPPE,
  runThermocycler
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  return {
    taskPages: state.notebook.protocolSection.scene.taskPages,
    solutions: state.notebook.protocolSection.scene.apparatus.solutions,
    tableData: state.notebook.protocolSection.tableData
  }
}

function mapDispatchToProps(dispatch) {
  return {
    showModal: (data) => {
      dispatch(showModal(data))
    },
    setModal: (data) => {
      dispatch(setModal(data))
    },
    incSolution: (data) => {
      dispatch(incSolution(data))
    },
    decSolution: (data) => {
      dispatch(decSolution(data))
    },
    setSolutionMixed: (data) => {
      dispatch(setSolutionMixed(data))
    },
    prepareGelBox: (data) => {
      dispatch(prepareGelBox(data))
    },
    runGel: (data) => {
      dispatch(runGel(data))
    },
    visualizeGel: (data) => {
      dispatch(visualizeGel(data))
    },
    loadDNALadder: (data) => {
      dispatch(loadDNALadder(data))
    },
    putOnPPE: (data) => {
      dispatch(putOnPPE(data))
    },
    runThermocycler: (data) => {
      dispatch(runThermocycler(data))
    }
  };
}

export const AnimationSequence = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
